import { Action } from "redux";

import { TTableConfig } from "redux/reducers/tableReducer";

import * as types from "../actionTypes/tableActionTypes";

export function cleanTableColumnAction(): Action {
  return {
    type: types.CLEAN_TABLE_COLUMNS_ORDER,
  };
}

export interface ISaveTableConfig extends Action {
  tableConfig: TTableConfig;
}
export function setTableConfigSuccess(
  tableConfig: TTableConfig,
): ISaveTableConfig {
  return {
    type: types.SET_TABLE_CONFIG,
    tableConfig,
  };
}
